import { Input } from '@/components/form/Input';
import type { StepProps } from '@/sections/asset/components/tabs/credentials/RecipeWizard/RecipeWizard.types';

import { SectionIntro } from './shared';

interface OverviewStepProps extends StepProps {
  webAppUrl: string;
}

export function OverviewStep({ data, setData, webAppUrl }: OverviewStepProps) {
  return (
    <div className="space-y-5">
      <SectionIntro
        title="Add a login for this web app"
        body={
          <p>
            We&apos;ll use it to scan as a logged-in user.
            {webAppUrl && (
              <>
                {' '}
                Target:{' '}
                <span className="bg-chariot-background-secondary text-chariot-text-primary rounded px-1.5 py-0.5 font-mono text-xs">
                  {webAppUrl}
                </span>
              </>
            )}
          </p>
        }
      />

      <Input
        label="Name this login"
        name="recipe-label"
        value={data.label}
        onChange={e => setData(prev => ({ ...prev, label: e.target.value }))}
        placeholder='e.g. "Production admin login"'
        required
        data-testid="wizard-recipe-label"
      />
    </div>
  );
}
